module.exports = __webpack_public_path__ + "img/copy.8e4c83cf.svg";